import { SessionRootState } from './types';

const initialState: SessionRootState = {
  data: {
    user: {},
    token: '',
  },
  login: {
    isLoading: false,
    error: '',
  },
  forgotPassword: {
    isLoading: false,
    error: '',
  },
  resetPassword: {
    isLoading: false,
    error: '',
  },
  updateUser: {
    isLoading: false,
    error: '',
  },
  updatePassword: {
    isLoading: false,
    error: '',
  },
  updateAvatar: {
    isLoading: false,
    error: '',
  },
};

export default initialState;
